<div class="bg-[var(--assistance-bg,#FFEEDD)] p-4 pb-40 xl:pb-70">
  <div class="max-w-2xl mx-auto">
    <h2 class="headline-07 text-center text-xl md:text-2xl mb-6 text-[var(--assistance-txt_primary,#382100)]">
      Solicitar asistencia
    </h2>

    <!-- Cruz médica decorativa - Solo para cuentas específicas -->
    <div *ngIf="shouldShowMedicalCross()" class="flex justify-center mb-6">
      <img src="assets/logos/cruz-medica.svg" alt="Cruz médica" class="w-24 h-24 md:w-32 md:h-32" />
    </div>

    <p class="headline-06 text-[var(--assistance-txt_primary,#382100)] mb-4">Selecciona una opción</p>

    <div class="space-y-3">
      @for (servicio of serviciosRapidos; track servicio.clSubservicio) {
        <button (click)="logOption(servicio)" [ngClass]="getButtonClass(servicio.dsSubservicio)" class="cursor-pointer">
          <div class="headline-06 text-[var(--assistance-txt_primary,#382100)] flex items-center gap-2">
            <img [src]="servicio.icono" class="w-8 h-8" />
            {{ servicio.dsSubservicio }}
          </div>
          @if (shouldShowInfo(servicio.dsSubservicio)){
            <p class="ml-9 paragraph-default text-[var(--assistance-txt_primary,#382100)] mt-1">
              {{ servicio.mensaje }}
            </p>
          }
        </button>
      }
    </div>

    <div *ngIf="selectedOption">
      <p class="text-[var(--assistance-txt_primary,#382100)] font-bold mt-4 headline-04">
        Si puedes, selecciona un motivo (opcional)
      </p>
      <p class="paragraph-default mb-3 ">Nos ayudará a canalizar la ayuda necesaria</p>

      <button *ngFor="let motivo of motivos" (click)="selectMotivo(motivo.dsMotivo)" [ngClass]="getMotivoClass(motivo.dsMotivo)" class="cursor-pointer">
        {{ motivo.dsMotivo }}
      </button>
    </div>

    <div class="px-0 md:px-5">
      <button (click)="solicitarAhora()" [ngClass]="getMainButtonClass()" class="cursor-pointer">
        Solicitar ahora
      </button>

      <!-- Botones de WhatsApp y Llamar comentados -->
      <!-- 
      <div class="flex flex-col md:flex-row gap-4 mt-4" *ngIf="!selectedOption">
        <button (click)="goToWhatsApp()"
          class="button-medium w-full h-12 bg-[var(--assistance-btn_primary,#462A00)] text-white py-2 rounded-full flex items-center justify-center gap-2 cursor-pointer">
          <img src="assets/logos/whatsapp.svg" alt="alerta" class="w-5 h-5" />
          Iniciar WhatsApp
        </button>

        <button (click)="goToCall()" hidden
          class="button-medium w-full h-12 bg-[var(--assistance-btn_primary,#462A00)] text-white py-2 rounded-full flex items-center justify-center gap-2 cursor-pointer">
          <img src="assets/logos/call.svg" alt="alerta" class="w-5 h-5" />
          Llamar
        </button>

      </div>
      -->

      <!-- <div *ngIf="selectedOption" class="text-center">
        <p class="text-center paragraph-default text-[var(--assistance-txt_primary,#382100)] mt-3">
          ¿No estás seguro qué servicio necesitas?
        </p>
        <a href="#" class="button-medium underline">Contáctanos y te ayudaremos</a>
      </div> -->
    </div>
  </div>
</div>